import { createContext } from 'react'

const groupContext = createContext()

export default groupContext
